import { Navigate } from 'react-router-dom'
import { useAuth, type AuthState } from '@/app/providers/auth-context'
import { AuthLoadingScreen } from '@/components/AuthLoadingScreen'
import { PLAY_BOARD_PATH } from '@/features/play/copy'

/**
 * `/play` AFTER THE HUB (owner, 2026-09-07: "хаб... не нужная страница — пока
 * закоментируем").
 *
 * The public marketplace hub that lived here is out of service. The URL is not:
 * it is indexed, it carries `canonicalPath="/play"`, the public drawer still has
 * a row pointing at it, and so do the footer, About and Solutions. Deleting the
 * route would turn every one of those into a 404, so the route stays and only
 * its answer changes.
 *
 * THE ANSWER DEPENDS ON WHO IS ASKING, and this is the whole reason the redirect
 * is a component and not a bare `<Navigate>`:
 *
 *   - SIGNED IN → the board. That is the page the owner is sending people to,
 *     and it opens.
 *   - SIGNED OUT → `/clubs`. The board sits behind RequireAuth, so a bare
 *     redirect there would hand a stranger who followed a public link a login
 *     screen with no explanation of what they were about to see. `/clubs` is
 *     public, indexed, and the closest thing left to what the hub promised in
 *     its own SEO title — racket clubs near you. They can still sign in from the
 *     header and reach the board under its own name.
 *
 * `checking` renders the shared auth ring rather than guessing, so a signed-in
 * player on a cold load is never bounced to the signed-out answer and back.
 *
 * TO PUT THE HUB BACK: swap this element for `<PlayHubPage />` in routes/playRoutes.tsx
 * and restore `/play` in scripts/generate-sitemap.mjs. Nothing else was removed.
 */
export function playHubRedirectTarget(state: AuthState): string | null {
  if (state === 'checking') return null
  return state === 'authenticated' ? PLAY_BOARD_PATH : '/clubs'
}

export function PlayHubRedirect() {
  const { state } = useAuth()
  const target = playHubRedirectTarget(state)
  if (!target) return <AuthLoadingScreen label="Checking your session…" />
  return <Navigate to={target} replace />
}
